import { LOCALE_PREFIX_WITH_PATH_RE } from "./settings";

function normalizePath(pathname: string): string {
  const match = pathname.match(LOCALE_PREFIX_WITH_PATH_RE);
  return match ? match[2] || "/" : pathname;
}

export function isI18nTargetPage(pathname: string): boolean {
  const p = normalizePath(pathname);
  if (p === "/checkin") return true;
  if (p === "/invitation" || p.startsWith("/invitation?")) return true;
  if (p === "/reservation-status" || p.startsWith("/reservation-status?"))
    return true;
  if (
    p === "/tentative-reservations/accept" ||
    p.startsWith("/tentative-reservations/accept?")
  )
    return true;
  if (/^\/tentative-reservations\/[^/]+\/(profile|confirm|completed)$/.test(p))
    return true;
  if (/^\/reservations\/[^/]+$/.test(p)) return true;
  return false;
}
